import React, {useEffect, useState} from 'react';

export const Tile = () => {
    const [tokens, setTokens] = useState(null);

    useEffect(() => {
        const explicit = new URLSearchParams(window.location.search).get('tokens');
        if (explicit) {
            setTokens(explicit.split(',').map(t => t.trim()).filter(Boolean));
            return;
        }
        fetch('/users/', {credentials: 'include'})
            .then(r => r.json())
            .then(users => setTokens(users.map(u => u.token)));
    }, []);

    if (tokens === null) return <div style={{color: 'white', padding: 20}}>Loading players…</div>;
    if (tokens.length === 0) return <div style={{color: 'white', padding: 20}}>No players registered.</div>;

    const cols = chooseCols(tokens.length);

    return <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gridAutoRows: 'min-content',
        gap: 4,
        padding: 4,
        width: '100vw',
        minHeight: '100vh',
        backgroundColor: 'black',
        boxSizing: 'border-box'
    }}>
        {tokens.map(token => (
            <div key={token} style={{
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                backgroundColor: '#111',
                aspectRatio: '9 / 19.5'
            }}>
                <div style={{
                    color: 'white',
                    fontSize: 11,
                    padding: '2px 6px',
                    backgroundColor: '#222',
                    fontFamily: 'monospace',
                    flexShrink: 0
                }}>{token}</div>
                <iframe
                    src={`/?token=${encodeURIComponent(token)}`}
                    style={{flex: 1, border: 'none', width: '100%'}}
                    title={token}
                />
            </div>
        ))}
    </div>;
};

function chooseCols(n) {
    const tileAspect = 9 / 19.5;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    for (let c = 1; c <= n; c++) {
        const rows = Math.ceil(n / c);
        const tileW = vw / c;
        const tileH = tileW / tileAspect;
        if (rows * tileH <= vh) return c;
    }
    return n;
}
